// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"214":"polyfills-core-js","748":"polyfills-dom"}[chunkId] || chunkId) + "." + {"214":"3e4281a0","340":"8cd843b9","748":"0583c940","787":"458b0f5e"}[chunkId] + ".chunk.js";
};